import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/home/mousa/Documents/Projecty/lst-navigator/layouts/admin.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/mousa/Documents/Projecty/lst-navigator/layouts/default.vue").then(m => m.default || m)),
  "front-page": defineAsyncComponent(() => import("/home/mousa/Documents/Projecty/lst-navigator/layouts/front-page.vue").then(m => m.default || m))
}